import PropTypes from 'prop-types'
import React from 'react'
import IconButton from '../iconButton/IconButton'
import { TooltipProps } from '../tooltipManager/TooltipProps'
import './TableActions.scss'
const titleClassName = 'component-table-actions'

export default function TableActions(props) {
  return (
    <div className={titleClassName}>
      <div className={`${titleClassName}-label`}>{props.label}</div>
      <div className={`${titleClassName}-actions`}>
        {props.actions.map((action, index) => (
          <div key={index} className={`${titleClassName}-action`}>
            <IconButton {...action} />
          </div>
        ))}
      </div>
    </div>
  )
}

TableActions.propTypes = {
  label: PropTypes.string,
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      'tooltip-position': TooltipProps['tooltip-position'],
      'tooltip-text': TooltipProps['tooltip-text'],
      icon: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
      theme: PropTypes.oneOf(['primary', 'secondary']),
      onClick: PropTypes.func,
      disabled: PropTypes.bool
    })
  )
}

TableActions.defaultProps = {
  label: '',
  actions: []
}
